function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#414141",
  d: "M18.06 2.233C15.93.37 12.746.678 10.77 2.776l-.77.82-.769-.816C7.637 1.084 4.422.064 1.941 2.233c-2.452 2.154-2.581 6.02-.386 8.35l7.559 8.027c.242.257.562.39.883.39.32 0 .64-.129.882-.39l7.56-8.027c2.202-2.33 2.073-6.196-.38-8.35zm-.512 7.458l-7.532 8.027-7.562-8.027C.954 8.1.64 5.066 2.754 3.214c2.141-1.88 4.657-.519 5.579.462L10 5.448l1.668-1.772c.906-.964 3.445-2.33 5.578-.462 2.11 1.848 1.8 4.881.3 6.477z"
});

var SvgFavoriteInline = function SvgFavoriteInline(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgFavoriteInline;